import type { IntegrationLoginOption } from 'findef'
import type { BankIDLoginOption } from '@/integrations/finsquid/types'

export const parseLoginOptions = (
  userId: string,
  options: IntegrationLoginOption[],
  sameDevice: boolean
): BankIDLoginOption => {
  const bankidSSNOption = options.find((it) => it.loginMethod === 'bankidSSN')
  const bankidOption = options.find((it) => it.loginMethod === 'bankid')
  const loginMethod = bankidSSNOption?.loginMethod || bankidOption?.loginMethod || 'bankid'

  // bankidSSN and mitid require userId in loginOption, bankid does not
  const requiresUserId = loginMethod === 'bankidSSN' || loginMethod === 'mitid'

  return {
    loginMethod: loginMethod,
    ...(requiresUserId && { userId: userId }),
    sameDevice
  }
}
